// Saved filters — frontend API surface (/api/filters, saved-filter-routes.js).

import { client } from '@platform/http/api-client';

const enc = encodeURIComponent;

const filtersApi = {
  // { filters: [...], facets: { owners, spaces, groups }, isAdmin }
  async filtersList(params = {}) {
    return (await client.get('/api/filters', { params })).data;
  },
  // { canCreate } — may the caller save NEW filters / copies?
  async filterCanCreate() {
    return (await client.get('/api/filters/can-create')).data;
  },
  // Settings → Filters → "Who may save filters" (site admins).
  // { groups, source: 'settings'|'default', defaultGroups, adminGroup, people }
  async filterSavers() {
    return (await client.get('/api/filters/savers')).data;
  },
  async filterSaversUpdate(groups) {
    return (await client.put('/api/filters/savers', { groups })).data;
  },
  async filterGet(id) {
    return (await client.get(`/api/filters/${enc(id)}`)).data;
  },
  // { name, jql, description?, columns?, viewers?, editors? }
  async filterCreate(payload) {
    return (await client.post('/api/filters', payload)).data;
  },
  // { name?, jql?, description?, columns? } — editors and up
  async filterUpdate(id, payload) {
    return (await client.put(`/api/filters/${enc(id)}`, payload)).data;
  },
  // { viewers?, editors? } as [{ type, value }] — owner/admin
  async filterUpdateShares(id, payload) {
    return (await client.put(`/api/filters/${enc(id)}/shares`, payload)).data;
  },
  async filterCopy(id, name) {
    return (await client.post(`/api/filters/${enc(id)}/copy`, { name })).data;
  },
  async filterChangeOwner(id, accountId) {
    return (await client.put(`/api/filters/${enc(id)}/owner`, { accountId })).data;
  },
  async filterDelete(id) {
    return (await client.delete(`/api/filters/${enc(id)}`)).data;
  },
  async filterStar(id, on) {
    return on
      ? (await client.put(`/api/filters/${enc(id)}/star`)).data
      : (await client.delete(`/api/filters/${enc(id)}/star`)).data;
  },
  // Every account on the system for the sharing / owner pickers (the
  // default /api/users page is 50 — a site has more people than that).
  async filtersUsers() {
    return (await client.get('/api/users', { params: { query: '', maxResults: 500 } })).data;
  },
  // Subscriptions — every call answers { subscriptions: [...] }
  async filterSubscriptions(id) {
    return (await client.get(`/api/filters/${enc(id)}/subscriptions`)).data;
  },
  async filterSubscribe(id, payload) {
    return (await client.post(`/api/filters/${enc(id)}/subscriptions`, payload)).data;
  },
  async filterSubscriptionUpdate(id, sid, payload) {
    return (await client.put(`/api/filters/${enc(id)}/subscriptions/${enc(sid)}`, payload)).data;
  },
  async filterSubscriptionDelete(id, sid) {
    return (await client.delete(`/api/filters/${enc(id)}/subscriptions/${enc(sid)}`)).data;
  },
  async filterSubscriptionSend(id, sid) {
    return (await client.post(`/api/filters/${enc(id)}/subscriptions/${enc(sid)}/send`)).data;
  },
};

export default filtersApi;
